import RuntimeUtils from 'src/common/js/runtimeUtils';
import { $get, $post, $put } from 'src/utils/httpUtil';

// 查询应用信息
export const getAppInfo = () => new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/clients/search`;
    $get(url).then((res) => {
        resolve(res);
    });
});

// 创建应用
/*
*
    remark: "我的应用描述",
    clientName: "我的应用",
    company: "北京构力"
*/
export const createApp = (data) => new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/clients`;
    $post(url, data).then((res) => {
        resolve(res);
    });
});

// 修改应用
/*
*
    remark: "我的应用描述",
    clientName: "我的应用",
    company: "北京构力"
*/
export const updateApp = (data) => new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/clients/`;
    $put(url, data).then((res) => {
        resolve(res);
    });
});



// WEBPACK FOOTER //
// ./src/utils/appUtils.js